/**
 * Decides what LKVideoCallPortal should do to the real LiveKit camera when
 * the activity/chat camera screen opens or closes (`cameraOn`).
 *
 * Two different screens share this one flag: a separate device webcam
 * capture (this portal must release the live camera first, to avoid two
 * getUserMedia calls fighting over the same device) and the live-track-reuse
 * capture (`reusesLiveTrack` — it's the exact feed on screen, still being
 * sent to other participants, so it must stay untouched).
 */

export const CameraPortalAction = {
    NONE: "none",
    RELEASE_CAMERA: "release_camera",
    MUTE_ONLY: "mute_only",
    RESTORE_CAMERA: "restore_camera",
}

export function decideCameraPortalAction({
    cameraOn,
    reusesLiveTrack,
    isCameraEnabled,
    isVideoMuted,
}) {
    if (cameraOn) {
        if (reusesLiveTrack) return CameraPortalAction.NONE

        return isCameraEnabled
            ? CameraPortalAction.RELEASE_CAMERA
            : CameraPortalAction.MUTE_ONLY
    }

    // Returning: only restore a camera the student hadn't muted themselves
    // before entering. A reuse-path return also lands here with
    // isVideoMuted=false (it was never actually released) — re-enabling an
    // already-enabled camera is a guaranteed no-op in the SDK (unmute()
    // short-circuits on `!this.isMuted`), not a real restart.
    return isVideoMuted ? CameraPortalAction.NONE : CameraPortalAction.RESTORE_CAMERA
}
